/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

export interface GlobalSnackbarState {
  notificationText: string | null | undefined;
  linkText?: string | null | undefined;
  linkTarget?: string | null | undefined;
  modalSpinnerVisible: boolean;
}

const initialState: GlobalSnackbarState = {
  notificationText: null,
  linkText: null,
  linkTarget: null,
  modalSpinnerVisible: false,
};

export const globalSnackbarSlice = createSlice({
  name: 'globalSnackbar',
  initialState,
  reducers: {
    showGlobalSnackbar: (state, action: PayloadAction<GlobalSnackbarState>) => {
      state.notificationText = action.payload.notificationText;
      state.linkText = action.payload.linkText;
      state.linkTarget = action.payload.linkTarget;
    },
    hideGlobalSnackbar: (state) => {
      state.notificationText = null;
      state.linkText = null;
      state.linkTarget = null;
    },
    showModalSpinner: (state) => {
      state.modalSpinnerVisible = true;
    },
    hideModalSpinner: (state) => {
      state.modalSpinnerVisible = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.notificationText = null;
      state.linkText = null;
      state.linkTarget = null;
      state.modalSpinnerVisible = false;
    });
  },
});

export const {
  showGlobalSnackbar,
  hideGlobalSnackbar,
  showModalSpinner,
  hideModalSpinner,
} = globalSnackbarSlice.actions;

export default globalSnackbarSlice.reducer;
